// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4z-2";
export var blackBorderOnHover = "_4z-7";
export var cell = "_4z-6";
export var cellContainer = "_4z-3";
export var checked = "_4z-8";
export var disabled = "_4z-5";
export var featuredIconCellContainer = "_4z-9";
export var featuredIconTextContainer = "_4z-b";
export var featuredIconWrapper = "_4z-a";
export var noBorder = "_4z-c";
export var orangeSelectedRow = "_d1-3";
export var overflowableText = "_4z-0";
export var overflowableTextContainer = "_4z-1";
export var row = "_54-0";
export var rowCheckboxCell = "_4z-4";
export var selectableTable = "_d1-2";